import { useStaticQuery, graphql } from 'gatsby';

export const useG2BadgesLogosQuery = () => {
  const data = useStaticQuery(graphql`
    query G2BadgesLogos {
      wp {
        sitewideSettings {
          optionsSitewideSettings {
            g2BadgesLogos {
              logosOrganism {
                eyebrow
                headline
                subhead
                useAnimatedScroll
                logos {
                  url
                  image {
                    altText
                    gatsbyImage: wpGatsbyImage(
                      placeholder: BLURRED
                      width: 196
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const logosOrganism = data?.wp?.sitewideSettings?.optionsSitewideSettings?.g2BadgesLogos;

  return logosOrganism;
};
